import React, { useState } from 'react';
import { FadeIn } from './FadeIn';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const faqs = [{
  q: '¿Necesito inglés perfecto para usar este sistema?',
  a: 'No. El sistema se enfoca en la eficiencia operativa. El profesionalismo se demuestra con orden, no solo con palabras.'
}, {
  q: '¿Funciona si solo tengo un cliente ahora mismo?',
  a: 'Es el mejor momento. Si organizas tu estructura ahora, podrás aceptar 3 clientes más sin aumentar tu nivel de estrés.'
}, {
  q: '¿Tengo que comprar software caro?',
  a: 'Para nada. La mayoría de las herramientas que recomiendo tienen versiones gratuitas muy potentes que son más que suficientes para empezar.'
}, {
  q: '¿Cuánto tiempo toma implementar el sistema?',
  a: 'Puedes leer la guía en una tarde y aplicar el Triple Filtro desde tu primer café de mañana.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 md:py-32 bg-white" data-id="element-46">
      <div className="max-w-3xl mx-auto px-6 lg:px-8" data-id="element-47">
        <FadeIn data-id="element-48">
          <div className="text-center mb-16" data-id="element-49">
            <h2 className="text-3xl md:text-4xl font-bold text-brand-charcoal mb-4" data-id="element-50">
              Preguntas Frecuentes
            </h2>
            <div className="w-24 h-1 bg-brand-gold mx-auto" data-id="element-51"></div>
          </div>
        </FadeIn>

        <div className="space-y-4" data-id="element-52">
          {faqs.map((faq, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-53">
              <div className="border border-brand-cream rounded-sm overflow-hidden" data-id="element-54">
                <button className="w-full text-left px-6 py-5 bg-brand-cream/50 hover:bg-brand-cream transition-colors flex justify-between items-center" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-55">
                  <span className="font-bold text-brand-charcoal pr-8" data-id="element-56">
                    {faq.q}
                  </span>
                  {openIndex === index ? <ChevronUp className="w-5 h-5 text-brand-gold flex-shrink-0" data-id="element-57" /> : <ChevronDown className="w-5 h-5 text-brand-gold flex-shrink-0" data-id="element-58" />}
                </button>
                <AnimatePresence data-id="element-59">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-60">
                      <div className="px-6 py-5 bg-white text-brand-charcoal/80 leading-relaxed border-t border-brand-cream" data-id="element-61">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}